module.exports = __webpack_public_path__ + "r-v3/img/x_gray.11c37ac0.svg";